import React, { FC } from 'react';
import { RGBColor } from 'react-color';
import { Container } from './styles';
import logo from '../../assets/Fight.svg';

interface LeftHeaderProps {
  bgColor: RGBColor;
  color: string;
  title: string;
}

const LeftHeader: FC<LeftHeaderProps> = ({ bgColor, color, title }) => {

  return (
    <Container r={bgColor.r} g={bgColor.g} b={bgColor.b} color={color}>
      <div className="logo">
        <img src={logo} alt="Fight analytics logo" />
      </div>
      <div className="title">{title}</div>
    </Container>
  );
};

export default LeftHeader;
